import DataDisplaysColorizedCategorizableController from "../../../data_displays/assets/javascript/data-displays-colorized-categorizable-controller"

export default class extends DataDisplaysColorizedCategorizableController {
  expandStroke(event) {
    dispatchCustomEvent(this.focusEventName, this.element, { color: this.color })
  }

  reduceStroke(event) {
    dispatchCustomEvent(this.unfocusEventName, this.element, { color: this.color })
  }

  enlarge() {
    this.element.classList.add("enlarged")
    this.strokeWidth = this.defaultStroke * 1.5
  }

  shrink() {
    this.element.classList.remove("enlarged")
    this.strokeWidth = this.defaultStroke
  }

  get defaultStroke() {
    return this.data.get("stroke-width")
  }

  set strokeWidth(val) {
    this.element.style.strokeWidth = val
  }
}



// WEBPACK FOOTER //
// ./app/components/charts/assets/javascript/charts-donut-segment-controller.js